import { render, staticRenderFns } from "./DownloadReport.vue?vue&type=template&id=54b5e786&scoped=true"
import script from "./DownloadReport.vue?vue&type=script&lang=js"
export * from "./DownloadReport.vue?vue&type=script&lang=js"
import style0 from "./DownloadReport.vue?vue&type=style&index=0&id=54b5e786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b5e786",
  null
  
)

export default component.exports